import React, { useContext, useState } from "react";
import RoutesToDblyLinkedList, { RouteOrder } from "../constants/Routes";

const RouteContext = React.createContext();

export const RouteProvider = ({ children }) => {
  const [routes] = useState(RoutesToDblyLinkedList(Object.keys(RouteOrder)));

  return (
    <RouteContext.Provider value={{ routes }}>{children}</RouteContext.Provider>
  );
};

export const useRoute = () => {
  return useContext(RouteContext);
};
